<ng-container *ngIf="!globals.hideHeaderFooter && !globals.hideFooter">

<section class="nf-disclosure-section" aria-labelledby="nf-disclosures-title">
  <div class="nf-container">
    <h2 class="nf-disclosure-title" id="nf-disclosures-title">Important disclosures</h2>
    <div class="nf-legal-text">
      <p>The data provided in charts referring to IFA Index Portfolios is hypothetical back-tested performance and is not actual client performance. Performance data for the IFA Index Portfolios is shown net of IFA's highest advisory fee and the underlying mutual fund expenses. IFA Indexes when shown individually do not reflect a deduction of advisory fees. None of the data reflects trading costs or taxes, which would have lowered performance by these costs. See more important disclosures at <a class="nf-inline-link" routerLink="/disclosures">ifabt.com</a>.</p>
    </div>
  </div>
</section>

<footer class="nf">
  <div class="nf-container">

    <div class="nf-top">
      <p class="nf-tag">Invest and Relax.</p>
      <nav class="nf-cols" aria-label="Footer">
        <div>
          <h2 class="nf-heading">Our Services</h2>
          <ul class="nf-list">
            <li><a class="nf-link" routerLink="/services">Individuals &amp; Families</a></li>
            <li><a class="nf-link" routerLink="/ocio">IFA OCIO</a></li>
            <li><a class="nf-link" routerLink="/retirement-plans">Employer Retirement Plans</a></li>
            <li><a class="nf-link" routerLink="/taxes">Tax Planning &amp; Preparation</a></li>
          </ul>
        </div>
        <div>
          <h2 class="nf-heading">Portfolios</h2>
          <ul class="nf-list">
            <li><a class="nf-link" routerLink="/survey">Risk Capacity Survey</a></li>
            <li><a class="nf-link" routerLink="/portfolios/ifa-index-portfolios">IFA Index Portfolios</a></li>
            <li><a class="nf-link" routerLink="/disclosures">Performance disclosures</a></li>
          </ul>
        </div>
        <div>
          <h2 class="nf-heading">Learn</h2>
          <ul class="nf-list">
            <li><a class="nf-link" routerLink="/articles">Articles and research</a></li>
            <li><a class="nf-link" routerLink="/12steps/introduction">The 12-Step Recovery Program</a></li>
            <li><a class="nf-link" routerLink="/charts">IFA charts</a></li>
          </ul>
        </div>
        <div>
          <h2 class="nf-heading">About IFA</h2>
          <ul class="nf-list">
            <li><a class="nf-link" routerLink="/about">Our story</a></li>
            <li><a class="nf-link" routerLink="/fees">Fees</a></li>
            <li><a class="nf-link" routerLink="/contact">Contact</a></li>
            <li><a class="nf-link" routerLink="/careers">Careers</a></li>
          </ul>
        </div>
      </nav>
    </div>

    <div class="nf-legal">
      <ul class="nf-utility" aria-label="More from IFA">
        <li><a class="nf-inline" routerLink="/disclosures/terms">Terms</a></li>
        <li><a class="nf-inline" href="https://www.ifa.com/pdfs/ifa-form-crs.pdf">Form CRS<span class="nf-sr"> (PDF)</span></a></li>
        <li><a class="nf-inline" routerLink="/disclosures/index-data">Index Descriptions</a></li>
        <li><a class="nf-inline" routerLink="/disclosures/fund-data">Fund Descriptions</a></li>
        <li><a class="nf-inline" routerLink="/glossary">Glossary</a></li>
        <li><a class="nf-inline" routerLink="/videos">Videos</a></li>
        <li><a class="nf-inline" routerLink="/app">IFA Apps</a></li>
        <li><button type="button" class="nf-inline nf-link-btn" (click)="newsletterSubscribeClick()" aria-haspopup="dialog">Newsletter Subscribe</button></li>
        <li><a class="nf-inline" href="https://wealth.emaplan.com/ema/Default.aspx?ema/ria/ifa" target="_blank" rel="noopener">eMoney<span class="nf-sr"> (opens in a new tab)</span></a></li>
        <li><a class="nf-inline" href="{{globals.amazonIndexFundsTwelveStepKindleUrl}}" target="_blank" rel="noopener">Index Funds Book on Kindle<span class="nf-sr"> (opens in a new tab)</span></a></li>
        <li><a class="nf-inline" href="{{globals.amazonIndexFundsTwelveStepAudioBookUrl}}" target="_blank" rel="noopener">Index Funds Audiobook<span class="nf-sr"> (opens in a new tab)</span></a></li>
        <li><a class="nf-inline" href="https://www.youtube.com/user/IndexFundsAdvisors" target="_blank" rel="noopener">YouTube<span class="nf-sr"> (opens in a new tab)</span></a></li>
        <li><a class="nf-inline" href="https://www.linkedin.com/company/index-funds-advisors-inc-?trk=top_nav_home" target="_blank" rel="noopener">LinkedIn<span class="nf-sr"> (opens in a new tab)</span></a></li>
        <li><a class="nf-inline" href="https://www.facebook.com/ifadotcom" target="_blank" rel="noopener">Facebook<span class="nf-sr"> (opens in a new tab)</span></a></li>
        <li><a class="nf-inline" href="https://twitter.com/ifadotcom" target="_blank" rel="noopener">X<span class="nf-sr"> (formerly Twitter, opens in a new tab)</span></a></li>
        <li><a class="nf-inline" href="https://www.instagram.com/indexfundadvisors/" target="_blank" rel="noopener">Instagram<span class="nf-sr"> (opens in a new tab)</span></a></li>
      </ul>
      <p>Index Fund Advisors, Inc. &middot; {{ globals.phoneTollFree }} &middot; IFA.com</p>
      <p>
        &copy; 1999&ndash;{{ globals.currentYear }} Index Fund Advisors, Inc. All Rights Reserved
        <span class="nf-sep" aria-hidden="true">|</span>
        {{ globals.mainAddress }}
        <span class="nf-sep" aria-hidden="true">|</span>
        <a class="nf-inline" href="tel:{{globals.phoneTollFree}}">{{ globals.phoneTollFree }}</a>
      </p>
    </div>

  </div>
</footer>

</ng-container>

<!-- Newsletter sign-up: native <dialog>, no Bootstrap -->
<dialog #subscribeDialog class="nf-dialog" aria-labelledby="nf-dialog-title" (click)="onDialogClick($event)" (close)="onDialogClosed()">
  <div class="nf-dialog-body">
    <button type="button" class="nf-close" (click)="closeSubscribe()">Close</button>

    <h2 class="nf-dialog-title" id="nf-dialog-title">Newsletter</h2>

    <p class="nf-dialog-success" *ngIf="emailSubscribed" role="status">You are now subscribed!</p>

    <form [formGroup]="subscribeForm" (ngSubmit)="submitEmailSubscribe()" *ngIf="!emailSubscribed" novalidate>
      <p class="nf-dialog-lead">Subscribe to receive IFA newsletters and timely industry insights.</p>

      <label class="nf-label" for="newsletter_subscribe_email">Email address</label>
      <input id="newsletter_subscribe_email" class="nf-input" autofocus formControlName="email" type="email"
             autocomplete="email" inputmode="email" autocapitalize="off" spellcheck="false"
             [attr.aria-invalid]="subscribeForm.invalid && (subscribeForm.dirty || subscribeForm.touched) ? 'true' : null"
             aria-describedby="nf-email-error">
      <p id="nf-email-error" class="nf-error" *ngIf="subscribeForm.invalid && (subscribeForm.dirty || subscribeForm.touched)">
        Please enter a valid email.
      </p>

      <button id="emailSubscribeButton" class="nf-button" type="submit" [disabled]="emailSubscribeSubmitting">
        {{ emailSubscribeSubmitting ? 'Subscribing…' : 'Subscribe' }}
      </button>
    </form>
  </div>
</dialog>
